'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./helpers/utils');

var _locales = require('./locales');

var _Checkmark = require('./icons/Checkmark');

var _Checkmark2 = _interopRequireDefault(_Checkmark);

var _ChevronDown = require('./icons/ChevronDown');

var _ChevronDown2 = _interopRequireDefault(_ChevronDown);

var _ChevronLeft = require('./icons/ChevronLeft');

var _ChevronLeft2 = _interopRequireDefault(_ChevronLeft);

var _ChevronRight = require('./icons/ChevronRight');

var _ChevronRight2 = _interopRequireDefault(_ChevronRight);

var _ChevronUp = require('./icons/ChevronUp');

var _ChevronUp2 = _interopRequireDefault(_ChevronUp);

var _Facebook = require('./icons/Facebook');

var _Facebook2 = _interopRequireDefault(_Facebook);

var _MultipleDates = require('./icons/MultipleDates');

var _MultipleDates2 = _interopRequireDefault(_MultipleDates);

var _Pin = require('./icons/Pin');

var _Pin2 = _interopRequireDefault(_Pin);

var _Search = require('./icons/Search');

var _Search2 = _interopRequireDefault(_Search);

var _Twitter = require('./icons/Twitter');

var _Twitter2 = _interopRequireDefault(_Twitter);

var _X = require('./icons/X');

var _X2 = _interopRequireDefault(_X);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CaligramReact() {
  var currentConfig = {
    // Each icon is manually specified to avoid dynamic requires
    icons: {
      checkmark: _Checkmark2.default,
      chevronDown: _ChevronDown2.default,
      chevronLeft: _ChevronLeft2.default,
      chevronRight: _ChevronRight2.default,
      chevronUp: _ChevronUp2.default,
      facebook: _Facebook2.default,
      multipleDates: _MultipleDates2.default,
      pin: _Pin2.default,
      search: _Search2.default,
      twitter: _Twitter2.default,
      x: _X2.default
    },
    locale: 'fr',
    locales: {
      fr: _locales.fr,
      en: _locales.en
    }
  };

  function config(newConfig) {
    if (newConfig) {
      currentConfig = (0, _utils.deepMerge)(currentConfig, newConfig);
    }
    return currentConfig;
  }

  this.config = config;
}

exports.default = new CaligramReact();


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/config.js
// module id = 674
// module chunks = 0